{
  "en": {
    "company": {
      "noMembership": {
        "card1": {
          "heading": "Activate access to license group",
          "description": "Your institution already has a license? Enter the 8-digit activation code to activate your access."
        },
        "card2": {
          "heading": "No license yet?",
          "description": "With a license for your school or educational institution, you can use fobizz together with colleagues. Tip: A license is often worthwhile from as few as 5 people!",
          "groupLicenseLink": "Learn more about group licenses",
          "consultationLink": "Schedule consultation"
        }
      },
      "shell": {
        "school": "My School",
        "workshops": "Internal workshops",
        "material": "My Materials",
        "certificate": "Certificate",
        "administration": "License administration",
        "adminInfo": "Information",
        "adminMemberships": "Members and license",
        "adminEvaluations": "Evaluation",
        "adminLegals": "Legal",
        "internal": "fobizz internal",
        "selectSchool": "Select a school",
        "switchSchool": "Switch view",
        "selectGroup": "Select a period"
      },
      "overview": {
        "endedAlert": "The term of your group license has ended. Please get in touch with our team.",
        "internalAnnouncements": "Internal Announcements",
        "internalAnnouncementsAdminInstructions": "As a coordinator of this license group, you have permission to edit this area.",
        "editAnnouncements": "Edit internal announcements",
        "saveAnnouncements": "Update message",
        "cancelAnnouncements": "Cancel",
        "selectedCourses": "Recommendations",
        "license": "My school license",
        "yourContact": "Your contact person is | Your contact persons are",
        "licenseHint": "You can find information about your licenses under <a href=\"/profile/licenses\" class=\"fw-semibold\">My Licenses</a>."
      },
      "workshops": {
        "heading": "Internal workshops",
        "paragraph": "Discover workshops customized to your school and explore them together with your colleagues.",
        "link": "Discover workshops for your school",
        "current": "Current workshops",
        "past": "Past workshops"
      },
      "certificate": {
        "congratulations": "Congratulations!",
        "courseCompleted": "Great work! You have completed this course.",
        "downloadPrompt": "Download your certificate now.",
        "surveyPrompt": "We would really like to get your feedback",
        "surveyLink": "Join Survey",
        "downloadLink": "Download here"
      },
      "material": {
        "heading": "Course Material",
        "fields": {
          "title": "Title",
          "url": "Fobizz tools URL to my project",
          "acceptShared": "I agree to share my learning material with fobizz and the fobizz community."
        },
        "urlHelp": "Submit your teaching materials here. Use the template to present and integrate your content. Important: Share the preview link.",
        "submit": "Submit material",
        "edit": "Edit",
        "back": "Back",
        "confirmationHint": "Your project has been successfully received by us. An additional confirmation email will not be sent."
      },
      "adminLegals": {
        "heading": "Legal"
      },
      "adminReports": {
        "heading": "Enrollments",
        "allLicensesEnrollments": "Enrollment across all licenses of this institution | Enrollments across all licenses of this institution",
        "licenseEnrollments": "Enrollment via this license | Enrollments via this license",
        "topic": "Course title",
        "count": "Count"
      },
      "adminEvaluations": {
        "heading": "Evaluation",
        "intro": "Here you will find a summary of the feedback within this group.",
        "noFeedback": "There is not enough feedback for a rating yet. Please be patient.",
        "rating": "How were the training courses rated on average?",
        "noRating": "No star rating available.",
        "recommendationScore": "What is the average recommendation rate of fobizz?",
        "noRecommendationScore": "No referral rate available.",
        "publicComment": "What do members say about the training courses?",
        "publicCommentTooltip": "Good to know: Reviews are given voluntarily. Public reviews are only written by a few people.",
        "noPublicComment": "No reviews available.",
        "metabaseDashboard": "Metabase evaluations dashboard",
        "schoolFilter": {
          "label": "Filter by school",
          "allSchools": "All schools"
        }
      },
      "adminMemberships": {
        "heading": "Members and license",
        "inviteMembers": "Invite members",
        "manageMembers": "Manage members",
        "searchPlaceholder": "Name or email address",
        "search": "Search...",
        "copySuccess": "Link copied!",
        "members": "member | members",
        "summary": {
          "groupAdmin": "Fobizz coordinator",
          "manageAdmins": "Manage admins",
          "orderEndsAt": "End of the license period",
          "package": "License package",
          "requestMoreLicenses": "Request more licenses"
        },
        "activationCode": {
          "title": "Activation code for new members",
          "description": "With this code, all colleagues can join this license group via {url}.",
          "copyButton": "Copy link including code"
        },
        "invitationOptions": {
          "title": "More options to invite new members to the group:",
          "emailCard": "Invitation via email",
          "posterCard": "Print poster",
          "linkCard": "Copy link including code"
        },
        "table": {
          "name": "Name",
          "email": "Email address",
          "status": "Status",
          "createdAt": "Joined at",
          "actions": "Actions"
        },
        "actions": {
          "extend": "Extend",
          "remove": "Remove"
        },
        "confirm": {
          "extend": {
            "title": "Extend runtime?",
            "text": "The runtime for {name} will be extended. One extension equals one license."
          },
          "remove": {
            "title": "Remove member?",
            "text": "This action cannot be undone. {name} will be removed from the group and lose access to the school license."
          }
        },
        "error": {
          "actionFailed": "The action could not be performed. Reloading the page will show the current status.",
          "invitationFailed": "The invitation could not be sent. Reloading the page will show the current status."
        },
        "pagination": {
          "previous": "Previous",
          "next": "Next",
          "page": "Page {current} of {total}"
        },
        "emailModal": {
          "title": "Send invitation via email",
          "placeholder": "Enter all email addresses.",
          "hint": "Enter the email addresses of everyone who needs to receive access.",
          "helpInvalidAddresses": "Invalid addresses will be marked in red.",
          "helpMailingLists": "Aliases / Emails directed to mailing lists cannot be processed.",
          "submit": "Send"
        }
      },
      "license": {
        "courses": {
          "title": "fobizz professional development",
          "description": "Access to all fobizz professional development courses, incl. AI training",
          "linkLabel": "to the professional development catalog"
        },
        "tools": {
          "title": "fobizz tools & AI assistants",
          "description": "Access to fobizz tools for teaching, incl. AI tools and AI classrooms for students",
          "linkLabel": "fobizz tools & AI assistants"
        },
        "toTeach": {
          "title": "to teach learning materials",
          "description": "Pro access for teaching staff to to teach: Differentiated lesson planning and materials",
          "linkLabel": "to teach learning materials"
        },
        "status": {
          "active": "Active",
          "trial": "Trial Plan",
          "exceeded": "Expired",
          "nonActive": "Not active",
          "confirmed": "Confirmed"
        },
        "activeUntil": "Access valid until",
        "activeFrom": "Access valid from {startDate} to {endDate}",
        "generalActiveUntil": "License valid until",
        "upgradeText": "Upgrade for {months} months:",
        "requestUpgrade": "Request upgrade",
        "renewalHeadline": "Renewal Notice",
        "renewalText": "A renewal has already been booked for the group \"{groupName}\". The new license period for {licenses} will start on {startsAt}."
      },
      "membershipExceeded": {
        "member": {
          "heading": "Unfortunately, your license has expired.",
          "paragraph": "Get in touch with your school’s administrator and find out how you can continue to use fobizz with your colleagues.",
          "paragraphWithContact": "Talk to your school's contact person ({contactNames}) to find out how your school can continue using fobizz. | Talk to your school's contact persons ({contactNames}) to find out how your school can continue using fobizz.",
          "hintText": "Tip: If your group license cannot be extended, you can get an",
          "hintLink": "individual license",
          "hintSuffix": "."
        },
        "admin": {
          "heading": "Unfortunately, your license has expired.",
          "paragraph": "As school administrator, you can still access your group's {reportsLink}. You can also {extendLink} there.",
          "reportsLink": "dashboard and statistics",
          "extendLink": "extend your school’s license"
        },
        "salesContact": {
          "heading": "Welcome to your school's administration section",
          "textPrefix": "I will be happy to advise you on all questions relating to your license. You can reach me at",
          "textMiddle": "If you choose a",
          "calendarLink": "telephone appointment",
          "textSuffix": "here, I will call you back."
        }
      },
      "csv": "Export CSV",
      "print": "Print",
      "platformStats": {
        "allEnrollmentsCount": "Enrollment across all licenses | Enrollments across all licenses",
        "membershipsCount": "member | members",
        "continueUsingPart": "want to continue using fobizz"
      },
      "toolsStats": {
        "digitalTools": "used tools and created materials",
        "pinboardsAndTeacherboards": "pinboards and teaching boards",
        "wordcloudsAndWebsites": "wordclouds and websites",
        "worksheetsAndSurveys": "worksheets and surveys",
        "texteditor": "text document | text documents",
        "audiorecords": "audio recordings",
        "screenAndVideorecorder": "video- and screen recordings",
        "linksAndFilesharing": "links shortened and files shared",
        "aiTools": "AI prompts",
        "sharedSpaces": "projects with shared spaces",
        "sharedSpaceLinkInviteesCount": "active students"
      }
    }
  }
}
